var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"table-responsive border rounded"},[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.data,"hide-default-footer":"","dense":"","items-per-page":-1},scopedSlots:_vm._u([{key:"item.FechaCaptura",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                "+_vm._s(_vm.onFormat(item.FechaCaptura, _vm.country))+"\n            ")]}}],null,true)})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c6d03cf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/components/tables/Screen4.vue
// module id = null
// module chunks = 